function useDocumentTitle() {
}
export {
  useDocumentTitle
};
//# sourceMappingURL=useDocumentTitle.native.js.map
